import { Link } from "@tanstack/react-router";

interface Props {
  size?: "sm" | "md" | "lg";
  withDot?: boolean;
  to?: string;
}

// React port of landing-site's Wordmark.astro. Keep visuals 1:1 so the
// dashboard sidebar and the marketing nav read as the same product.
export function Wordmark({ size = "md", withDot = true, to = "/app" }: Props) {
  const sizeClass =
    size === "sm" ? "text-base" : size === "lg" ? "text-2xl" : "text-lg";

  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-1.5 font-display font-medium tracking-tight ${sizeClass} text-ink transition hover:opacity-80`}
    >
      {withDot && (
        <span className="relative inline-flex items-center">
          <span className="relative inline-flex h-2.5 w-2.5">
            <span className="absolute inset-0 rounded-full bg-peach" />
            <span
              className="absolute inset-0 animate-ping rounded-full bg-peach opacity-50"
              style={{ animationDuration: "3s" }}
            />
          </span>
          <span className="relative -ml-px inline-flex h-1.5 w-1.5">
            <span className="absolute inset-0 rounded-full bg-mint" />
            <span
              className="absolute inset-0 animate-ping rounded-full bg-mint opacity-50"
              style={{ animationDuration: "3s", animationDelay: "1s" }}
            />
          </span>
        </span>
      )}
      <span>
        RealFlow<span className="text-ink/40">.so</span>
      </span>
    </Link>
  );
}
